// import configOldObj from './config';// 待废弃
export const configGovern = (c) => {
  const plainApisKeyMapping = {
    apiAudit: 'ulcd',
    basebbs: 'bbs/bbsbase',
    bbsbase: 'bbs/bbsbase',
    bbs: 'bbs',
    bset: 'ssp',
    rank: 'ssp',
    ruledesign: 'ulcd',
    cc: 'bbs/cc',
    ac: 'bbs/ac',
    cer: 'ulcd',
    core: 'core',
    decorate: 'core',
    appGmcenter: 'gmcenterapp',
    archive: 'te',
    down: 'file',
    engAttend: 'o2o',
    // engbbs: 'bbs',
    // engeval: 'eval',
    enroll: 'utility',
    // eval: 'eval',
    // export: 'export',
    flip: 'o2o',
    hwbase: 'o2o',
    IM: 'msg',
    kng: 'kng',
    knglib: 'kng',
    msg: 'msg',
    notice: 'msg',
    clock: 'msg',
    or: 'msg',
    infomgmt: 'msg',
    reward: 'ssp',
    signup: 'utility',
    ssp: 'ssp',
    rewardboss: 'ssp',
    shoptour: 'bbs',
    o2o: 'o2o',
    o2orpt: 'o2o',
    // or: 'or',
    orginit: 'msg',
    // orgInit: 'orginit',
    ote: 'ote',
    survey: 'ote',
    talent: 'talent',
    tcm: 'tlive/tcm',
    te: 'te',
    teasbase: 'ote',
    tlive: 'tlive',
    // topenyy: 'topenyy',
    udp: 'udp',
    ulcd: 'ulcd',
    utility: 'utility',
    search: 'ulcd',
    exportPdfTool: 'exporttoolpdf',
    sptalent: 'sptalent',
    speval: 'ote',
    sptalentrv: 'sptalentrv',
    base: ''
    // xt: 'xt',
  };
  const scApisKeyMapping = {
    apiOpcs: 'opcs',
    // exportPdfTool: 'exportpdftool', 不能和，未改造
    file: 'file',
    global: 'opcs',
    jf: 'ssp',
    jfasync: 'ssp',
    jfboss: 'jf',
    misc: 'opcs',
    // monitoralert: 'monitoralert',
    // monitordata: 'monitordata',
    pay: 'utility',
    // polestar: 'polestar',
    // sch: 'sch',
    support: 'msg',
    isvmall: 'msg',
    isvmallboss: 'msg/isvmallboss',
    wallet: 'ssp',
    walletasync: 'ssp'
  };
  const infoApisKeyMapping = {
    // crm: 'crm',
    // op: 'op'
  };
  const socketApisKeyMapping = {
    flipSocket: 'websocketsvc'
  };

  // 报表接口 信创走双集群，其余走单集群
  window.feConfig.envAlias === '1683419934671298561-hw02'
    ? (plainApisKeyMapping.rpt2 = 'rpt2')
    : (scApisKeyMapping.rpt2 = 'rpt2');
  const apiCollection = [
    {
      baseUrlKey: 'apiBaseUrl',
      configMapping: plainApisKeyMapping
    },
    {
      baseUrlKey: 'scApiBaseUrl',
      configMapping: scApisKeyMapping
    },
    {
      baseUrlKey: 'infoBaseUrl',
      configMapping: infoApisKeyMapping
    },
    {
      baseUrlKey: 'wsBaseUrl',
      configMapping: socketApisKeyMapping
    }
  ];
  for (let i = 0; i < apiCollection.length; i++) {
    const {baseUrlKey, configMapping} = apiCollection[i];
    for (let configKey in configMapping) {
      if (c[configKey]) {
        c[configKey] = c[baseUrlKey] + configMapping[configKey] + '/';
      } else {
        c[configKey] = c[baseUrlKey] + '/';
      }
    }
  }
};

configGovern(window.feConfig && window.feConfig.common || {});
// 强依赖，feConfig 必须提前注入
const config = Object.assign({}, window.feConfig && window.feConfig.common);

/**
 *
 * @param {*} domain
 */
export function setDomainConfig(domain) {
  Object.assign(config, domain);
}

export const apiEnv = window.feConfig && window.feConfig.apiEnv || 'prod';
/**
 *
 */
export const source = 501;
/**
 *
 * @param {*} options
 * @returns
 */
export function transformApiParams(options) {
  options =
    typeof options === 'string'
      ? { env: options, source }
      : options;

  if (!options.domain) {
    options.domain = config;
  }

  if (!options.source) {
    options.source = source;
  }

  if (!options.env) {
    options.env = apiEnv;
  }

  return options;
}
/**
 *
 */
export default config;

